/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolStorefrontIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-storefront"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.15 21.5Q4.05 21.5 3.27 20.73Q2.5 19.95 2.5 18.85L2.5 11.25Q1.77 10.65 1.51 9.72Q1.25 8.8 1.6 7.75L2.75 4.2Q2.98 3.52 3.5 3.04Q4.03 2.55 4.75 2.55L19.25 2.55Q19.98 2.55 20.52 3.01Q21.07 3.48 21.3 4.2L22.4 7.75Q22.75 8.8 22.52 9.78Q22.3 10.75 21.5 11.25L21.5 18.85Q21.5 19.95 20.73 20.73Q19.95 21.5 18.85 21.5ZM14.25 9.7Q14.78 9.7 15.09 9.39Q15.4 9.07 15.3 8.5L14.75 5.2L13.35 5.2L13.35 8.65Q13.35 9.07 13.61 9.39Q13.88 9.7 14.25 9.7ZM9.65 9.7Q10.1 9.7 10.4 9.39Q10.7 9.07 10.7 8.65L10.7 5.2L9.25 5.2L8.7 8.45Q8.57 9.18 8.9 9.44Q9.22 9.7 9.65 9.7ZM5.1 9.7Q5.45 9.7 5.72 9.41Q6 9.13 6.05 8.75L6.55 5.2L5.2 5.2Q5.2 5.2 5.2 5.2Q5.2 5.2 5.2 5.2L4.2 8.35Q4.03 8.88 4.3 9.29Q4.58 9.7 5.1 9.7ZM18.9 9.7Q19.55 9.7 19.75 9.29Q19.95 8.88 19.8 8.35L18.85 5.2Q18.85 5.2 18.85 5.2Q18.85 5.2 18.85 5.2L17.45 5.2L17.95 8.75Q18 9.13 18.27 9.41Q18.55 9.7 18.9 9.7Z" fill={color} />
    </svg>
  );
}
